export const getWrapperClassName = (
  dragOver: boolean,
  dragOverError = false,
): string => {
  if (dragOverError) return 'text-neutral-700 border-red-200 bg-neutral-000';
  if (dragOver) return 'text-purple-400 border-purple-400 bg-purple-50';
  return 'text-neutral-700 border-neutral-300 bg-neutral-000';
};

export interface ConvertedFile {
  name: string;
  content: string;
  mimetype: string;
}

export interface ConvertedFileSuccess extends ConvertedFile {
  state: 'success';
}

export interface ConvertedFileError {
  state: 'error';
  error: string;
}

export type ConvertedFileState = ConvertedFileSuccess | ConvertedFileError;

export const convertFile = (file: File): Promise<ConvertedFileState> =>
  new Promise((resolve, reject) => {
    // Set up reader
    const reader = new FileReader();
    // Add onload function
    reader.onload = (event: ProgressEvent<FileReader>) => {
      const result = event.target?.result;
      if (!result || typeof result !== 'string') {
        const err = new Error('Error parsing file');
        reject(err);
        return;
      }
      resolve({
        state: 'success',
        name: file.name,
        content: result.split(',').slice(-1)[0],
        mimetype: file.type,
      });
    };
    reader.onerror = () => {
      const err = new Error('Error parsing file');
      reject(err);
    };
    reader.readAsDataURL(file);
  });

export const convertToBase64 = async (
  file: File,
): Promise<ConvertedFileSuccess | ConvertedFileError> => {
  try {
    const converted = await convertFile(file);
    return converted;
  } catch (_) {
    return {
      state: 'error',
      error: 'Error parsing file',
    };
  }
};
